export default function () {
  return {
    availableIdentifiers: [],
    blocks: {},
  }
}
